require('./sourceFieldDependency.i18n.json');
require('./sourceFieldDependency.tpl.html');
require('./sourceFieldDependencyController.js');

const SourceFieldDependencyComponent = {
    templateUrl: '/configuration/dataSetEditor/content/dynamicCriteria/sourceFieldDependency/sourceFieldDependency.tpl.html',
    controller: 'sourceFieldDependencyController',
    bindings: {
        sourceFieldDependency: '<'
    }
};

angular.module('ums.configuration')
    .component('sourceFieldDependency', SourceFieldDependencyComponent);
